import { EllipsisHorizontalIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/solid";
import { Avatar } from "@moe/oss/ui/avatar";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuShortcut,
  ContextMenuTrigger
} from "@moe/oss/ui/context-menu";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuShortcut,
  DropdownMenuTrigger
} from "@moe/oss/ui/dropdown-menu";
import { Chip } from "@moe/priv/components/ui/chip";
import { Persona } from "@moe/priv/model/persona";

interface Props {
  persona: Persona;
  isSelected?: boolean;
  onEdit: (persona: Persona) => void;
  onDelete: (persona: Persona) => void;
  onClick?: (persona: Persona) => void;
}

/**
 * An Item in the PersonaList.
 */
export function PersonaItem({ persona, isSelected, onEdit, onDelete, onClick }: Props) {
  return (
    <ContextMenu>
      <ContextMenuTrigger>
        <button
          className="text-tx-primary group flex h-fit w-full items-center justify-between overflow-x-hidden rounded-lg p-3 font-[480] transition duration-200 ease-out hover:brightness-90 focus:outline-none"
          onClick={() => onClick?.(persona)}
        >
          <div className="mr-3 flex items-center space-x-5 ">
            <Avatar src={persona.avatar} />
            <div className="flex w-full flex-col">
              <h3 className="line-clamp-1 text-ellipsis text-left text-base font-[550]">{persona.name}</h3>
              {persona.description && persona.description.length !== 0 && (
                <p className="text-tx-secondary line-clamp-1 text-ellipsis text-left text-sm font-[470]">
                  {persona.description}
                </p>
              )}
              <div className="flex gap-2">
                {persona.isDefault && <Chip size="sm">Default</Chip>}
                {isSelected && <Chip size="sm">Selected</Chip>}
              </div>
            </div>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <EllipsisHorizontalIcon className="text-tx-secondary size-5 shrink-0 cursor-pointer transition duration-75 ease-out md:opacity-0 md:group-hover:opacity-100" />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-36">
              <DropdownMenuGroup>
                <DropdownMenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onSelect={() => onEdit(persona)}
                >
                  Edit
                  <DropdownMenuShortcut>
                    <PencilIcon className="size-4" />
                  </DropdownMenuShortcut>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onSelect={() => onDelete(persona)}
                >
                  Delete
                  <DropdownMenuShortcut>
                    <TrashIcon className="size-4" />
                  </DropdownMenuShortcut>
                </DropdownMenuItem>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </button>
      </ContextMenuTrigger>

      <ContextMenuContent className="w-36">
        <ContextMenuItem onSelect={() => onEdit(persona)}>
          Edit
          <ContextMenuShortcut>
            <PencilIcon className="size-4" />
          </ContextMenuShortcut>
        </ContextMenuItem>

        <ContextMenuItem onSelect={() => onDelete(persona)}>
          Delete
          <ContextMenuShortcut>
            <TrashIcon className="size-4" />
          </ContextMenuShortcut>
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
